import React from 'react';

/**
 * True once the element has been on screen in a visible tab: the come-back
 * card mounts while the candidate is still on the employer's site, and a card
 * lower on the page can sit below the fold, so mounting is not being seen.
 */
const useSeen = (ref: React.RefObject<HTMLElement | null>) => {
  const [seen, setSeen] = React.useState(false);
  React.useEffect(() => {
    const el = ref.current;
    if (seen || !el || typeof IntersectionObserver === 'undefined') {
      return undefined;
    }
    let inView = false;
    const check = () => {
      if (inView && document.visibilityState === 'visible') setSeen(true);
    };
    const observer = new IntersectionObserver(
      ([entry]) => {
        inView = entry.isIntersecting;
        check();
      },
      { threshold: 0.5 },
    );
    observer.observe(el);
    document.addEventListener('visibilitychange', check);
    return () => {
      observer.disconnect();
      document.removeEventListener('visibilitychange', check);
    };
  }, [ref, seen]);
  return seen;
};

export default useSeen;
